import { Injectable } from '@angular/core';
import { Occupancy } from '../../models/occupancy';
import { BaseService, IKeyValuePair } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OccupancyService extends BaseService<Occupancy> {

  protected endpointUri = 'RoomReservation/Occupancies';

  getAll(): Observable<Occupancy[]> {
    throw new Error('Method not implemented.');
  }

  get(id: string): Observable<any> {
    throw new Error('Method not implemented.');
  }

  /**
   * POST Occupany (create new)
   *
   * @param {Occupancy} entity
   * @param {IKeyValuePair<string, string>[]} headers
   * @returns {Observable<Occupancy>}
   * @memberof OccupancyService
   */
  add(entity: Occupancy, headers: IKeyValuePair<string, string>[]): Observable<any> {
    return this.addRequest(null, entity, headers);
  }

  /**
   * PUT Occupany (edit existing)
   *
   * @param {Occupancy} entity
   * @returns {Observable<any>}
   * @memberof OccupancyService
   */
  update(entity: Occupancy): Observable<any> {
    return this.updateRequest(String(entity.LessonId), null, entity, []);
  }

  /**
   * DELETE Occupany (remove existing)
   *
   * @param {string} id
   * @returns {Observable<{}>}
   * @memberof OccupancyService
   */
  delete(id: string): Observable<{}> {
    return this.deleteRequest(id);
  }

}
